<template>
    <div class="suggestion-players" >
        <div class="suggestion-container" v-for="(player, index) in suggestions" :key="index">
            <div class="suggestion-team"
            :style="{
                'color': colors.theme == 'dark' ? '#697582' : '#697582'
            }"
            >
                <div class="name-player"
                :style="{
                    'color': colors.theme == 'dark' ? '#697582' : '#697582'
                }"
                >
                    {{ player.name }}
                </div>
                <p class="suggestion">
                    {{ player.suggestion }}
                </p>
            </div>
        </div>
        <div class="suggestion-container">
            <div class="suggetion-player" :style="lastBackgorund">
                <div class="name-player"
                :style="{
                    'color': colors.theme == 'dark' ? '#697582' : '#697582'
                }">
                    sua sugestão
                </div>
                <p class="suggestion sug-player">
                    {{selfSuggestion.attempt ? selfSuggestion.attempt : "--"}}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import Bus from '@/main.js'
export default {
    props: {
        team : {
            type: Array,
            required : true
        },
        index : {
            type : Number
        },
        lastBg : {
            type: Boolean,
            default : false
        },
        suggestions : {
            required: true
        },
        selfSuggestion : {
            required : true
        }
    },
    data(){
        return {
            colors:{}
        }
    },
    created(){
        Bus.$on(`resp-${this.index}`, this.alterSuggetions),
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    computed: {
        lastBackgorund(){
            let style = ''
            if(this.lastBg == true){
                style = `background-color : 'red'`
            }
            return style
        }
    }
}
</script>
<style lang="scss" scoped>
    .suggestion-players{

        width: 100%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        overflow-x: scroll;

        .suggestion-container{
            width: 90px;
            min-width: 70px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
        }

        .name-player{

            font-size: 9px;
            text-transform: uppercase;
            color: rgb(0, 0, 0);
            text-align: center;
        }

        .suggestion{
            font-weight: 700;
            font-size: 24px;
        }

        .suggetion-player, .suggestion-team{

            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .suggestion-team{

            border-right: 1px solid black;

            .name-player{

                white-space: nowrap; 
                width: 80%; 
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: center;
            }
        }

        .suggetion-player{

            font-weight: 600;
        }
    }

    @media only screen and (max-width : 350px) {

        .suggestion-players{

            width: 90%;
        }

    }

    @media only screen and (min-width : 600px) {

        .suggestion-players{
                
            width: 70%;

            .suggestion{

                font-size: 0.9em;
                font-weight: bold;
            }


            .name-player{

                font-size: 0.6em;
            }
            
        }
    }

    @media only screen and (min-width: 750px){

        .suggestion-players{
            overflow-x: inherit;

            .suggestion-container{
                width: 100px;
            } 
        }
    }

    
</style>
